const $ = jQuery

export const $body = $('body')
export const isPage = (id) => $body.hasClass(`page-id-${id}`)
export const isPageTemplate = (templateName) => $body.hasClass(`page-template-${templateName}`)
